
































































































































































































/*
  getParam 获取项目材料信息管理页面参数
  getProjectMaterialInfo 获取项目材料信息管理分页列表
  deleteTeacherInfo 删除项目材料信息
  markValid 标记是否有效
  setRecommend 推荐或取消推荐
  validTeacherNum 项目材料总人数/有效人数
  getMsgTeacher 根据获取短信项目材料名单
*/
import { Vue, Component } from "vue-property-decorator";
import { Form as ElForm } from "element-ui";
import Cookies from "js-cookie";
import moment from "moment";

//引入接口调用函数
import {
  getParam,
  getProjectMaterialInfo,
  deleteTeacherInfo,
  markValid,
  setRecommend,
  validTeacherNum,
  getMsgTeacher, downloadCl
} from "../../../api/projectMaterial";
import { getToken } from "../../../utils/auth";

//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

@Component({
  name: "teacherInfoManage",
  components: {
    detail: () => import("./modules/detail.vue"),
    edit: () => import("./modules/edit.vue"),
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private validTeacherData: object = {}; //项目材料总数及有效项目材料数量
  private projectId: string = ""; //项目id
  private projectLabel: string = ""; //项目展示标签
  private sourceId: string = ""; //来源
  private schoolName: string = ""; //单位名称
  private isRecommend: number | null = null; //是否重点推荐
  private isBlacklist: number | null = null; //是否是黑名单
  private teacherName: string = ""; //项目材料姓名
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  private chooseRowArray: object[] = []; //勾选的数据row 集合
  private showDetail: boolean = false; //是否显示详情
  private currentTeacherId: string = ""; //要查看的teacherId
  private dialogFormVisible: boolean = false; //是否显示添加\编辑弹窗
  private editType: string = ""; //记录是 "添加" 还是 "修改"
  private editFormData: object = {}; //添加\编辑弹窗的数据
  private isProvinceRole: boolean = false; //是否是“省级管理员”
  private msgType: string = ""; //发送短信息or发送通知
  //页面参数
  private projects: object[] = []; //项目数组
  private sources: object[] = []; //“来源”数组
  private schools: object[] = []; //学校数组
  private genders: object[] = []; //性别数组
  private subjects: object[] = []; //科目数组
  private professionals: object[] = []; //职称数组
  private grades: object[] = []; //任课年级数组
  private treeVos: object = {}; //收件人
  private districts: object = {}; //市区列表
  private dialogVisible: boolean = false; //对话框弹出
  private status: string = "1"; //是否忽略黑名单 1对应是，0对应不是
  private tableHeight: number = 0;
  private iframe:any = null  //装载pdf的iframe对象
  private breadcrumbName = '' //当前打印按钮名称
  public $refs!: {
    validate: HTMLFormElement;
    table: HTMLFormElement;
  };
  private uploadData = {status: this.status, projectId: this.projectId, progressId: -1};

  created() {
    //初始化data数据
    this.initDta();
    //获取项目材料总人数/有效人数
    this.getValidTeacherNum();
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  initDta() {
    const { projectLabel, projectId } = this.$route.query;
    if (projectLabel && projectId) {
      this.projectId = projectId as string;
      this.projectLabel = projectLabel as string;
    }
  }
//返回列表页
  private goBack(){
    if (this.iframe && this.iframe.src) {
      window.URL.revokeObjectURL(this.iframe.src);
    }

    this.$refs['iframeContainer'].removeChild(this.iframe);
    this.iframe = null
  }

  /**
   * “打印聘书”处理
   * @param {number} type 1为聘书，2为优秀证书
   */
  private async printHandle() {
    try{
      if (this.chooseIdArray.length <= 0) {
        this.$message.warning("请勾选一条记录！");
        return false;
      }
      if(this.chooseIdArray.length > 1) {
        this.$message.error("最多勾选一条记录！");
        return false;
      }
      let params = {
        materialId:  this.chooseIdArray[0], // 项目id
      }
      this.breadcrumbName ='查看材料';
      let res = await downloadCl(params);
      console.log(res);
      this.clearSelection() //清空选择
      this.previewPDF(res) //预览pdf
    }
    catch(error){
      this.clearSelection() //清空选择
      // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }
//清空表格选中
  private clearSelection(){
    this.$refs['table'].clearSelection()
  }
//预览pdf
  private previewPDF(res){
    //创建一个iframe
    this.iframe = document.createElement("iframe");
    this.iframe.setAttribute("frameborder", 0);
    this.iframe.style.width = "100%";
    this.iframe.style.height = "100%";
    this.$refs['iframeContainer'].appendChild(this.iframe);
    this.iframe.src = window.URL.createObjectURL(res)
  }
  //点击查看
  private async  showDetailHandle(materialId) {
    try{
      if (materialId==='' || materialId==null || materialId === undefined) {
        this.$message.warning("请选择一条记录！");
        return false;
      }
      let params = {
        materialId:  materialId, // 项目id
      }
      this.breadcrumbName ='查看材料';
      let res = await downloadCl(params);
      console.log(res);
      this.clearSelection() //清空选择
      this.previewPDF(res) //预览pdf
    }
    catch(error){
      this.clearSelection() //清空选择
      // this.$message.error(error || "操作失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  private dateFormat(row, column) {
    var date = row[column.property];
    if (date == undefined) {
      return "";
    }
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  }

  private changeValue(val) {
    this.projectId = val;
    this.sourceId = val;
    this.getData();
  }

  //获取项目材料总人数/有效人数
  private async getValidTeacherNum() {
    let projectId = this.projectId;
    let res = await validTeacherNum(projectId);
    this.validTeacherData = res.data;
  }

  private submitUpload() {
    let res = this.$refs[`upload`].submit();
    this.dialogVisible = false;
  }

  private handleClose(done) {
    this.dialogVisible = false;
  }

  private uploadSuccess(res) {
    this.dialogVisible = false;
    (this as any).handleUploadSuccess(res, '项目材料信息上传失败.xlsx');
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data.projects;
      this.sources = res.data.sources;
      this.schools = res.data.schools;
      this.genders = res.data.genders;
      this.subjects = res.data.subjects;
      this.professionals = res.data.professionals;
      this.grades = res.data.grades;
      this.districts = res.data.districts;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // "获取列表"接口和"获取短信项目材料名单"接口，传参
  private deliverParams () {
    return {
      current: this.pageNo, //当前页
      otherinfoIsRecommend: this.isRecommend, //是否推荐 0:是, 1:否
      otherinfoSourceId: this.sourceId, //来源id
      projectId: this.projectId, //项目id
      schoolName: this.schoolName, //单位名称
      size: this.pageSize, //记录数
      teacherIsBlacklist: this.isBlacklist, //是否黑名单 0:否 ; 1:是
      teacherName: this.teacherName //项目材料名称
    }
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getProjectMaterialInfo(this.deliverParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
    this.getValidTeacherNum();
  }

  //勾选处理
  private selectChangeHandle(v) {
    this.chooseIdArray = v.map(item => {
      return item.materialId;
    });
    // 勾选的单行的内容 -- 用于删除操作等
    this.chooseRowArray = [...v];
  }






  //点击“添加”或“编辑”弹窗处理
  private showEditDialog(type, row) {
    //记录是“添加”还是“修改”
    this.editType = type;
    //获取弹窗数据对象
    if (row) {
      this.editFormData = {
        materialProjectId: row.projectId,
        materialPath: row.materialPath,
        materialContent: row.materialContent,
        materialTitle: row.materialTitle,
        materialId: row.materialId
      };
    } else {
      this.editFormData = {};
    }
    //显示弹窗
    this.dialogFormVisible = true;
  }

  //删除处理
  private deleteHandle() {
    //操作前的校验
    // if (!this.operationCheck()) return false;
    // 需求更改后的逻辑
    if (this.chooseRowArray.length <= 0) {
      this.$message.warning("请先勾选！");
      return false;
    }
    //询问是否删除
    this.$confirm("确定删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      // let params = {
      //   ids: this.chooseIdArray
      // };
      // console.log(params);
      // 流程改之后
      let tempArr: Array<object> = [];
      this.chooseRowArray.forEach(v => {
        tempArr.push({
          materialId: v[`materialId`]
        });
      });
      try {
        await deleteTeacherInfo(tempArr);
        this.$message.success("删除成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        // this.$message.error(error || "删除失败");
        this[`$message`]({
          type: "error",
          message: error!.mesg ? error!.mesg : error
        });
      }
    });
  }



  //导出
  private exportHandle() {
    this.$nextTick(() => {
      let params = {
        current: this.pageNo,
        otherinfoIsBlacklist: this.isBlacklist,
        otherinfoIsRecommend: this.isRecommend,
        otherinfoSourceId: this.sourceId,
        projectId: this.projectId,
        schoolName: this.schoolName,
        size: this.pageSize,
        teacherName: this.teacherName,
        teacherIsBlacklist: this.isBlacklist //是否黑名单 0:否 ; 1:是
      };
      (this as any).downloadHandle("exportTeacherInfo", "项目材料信息.xlsx", params);
    });
  }

  // 删除、确认有效无效、推荐、取消推荐，操作前的校验
  private operationCheck() {
    if (!this.projectId) {
      this.$message.warning("请选择项目！");
      return false;
    } else if (!this.sourceId) {
      this.$message.warning("请选择来源！");
      return false;
    } else if (this.chooseIdArray.length <= 0) {
      this.$message.warning("请勾选！");
      return false;
    } else {
      return true;
    }
  }



  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
